module.exports = __webpack_public_path__ + "static/zapier-integrations-822658a96150cd15d81d5c20ccefd3d0.png";